import React from 'react';
import { DotWrapper } from './DotsStyles';

interface IProps {
  index: number;
  currentPage: number;
}

export const Dot: React.FC<IProps> = (props) => {
  const { index, currentPage } = props;
  return <DotWrapper className={`dot${currentPage === index ? ' active' : ''}`} />;
};
